<template>
  <tr
    class="cat-active-item activeItemRow"
    valign="top"
    :role="roleListItem ? 'listitem' : null"
  >
    <td
      :role="roleListItem ? 'group' : null"
      :aria-label="roleListItem ? groupDetailsLabel : null"
    >
      <div class="item-row">
        <cat-icon
          v-if="icon"
          class="item-icon"
          :icon="icon"
          :iconLabel="iconLabel ? iconLabel : icon"
        ></cat-icon>
        <div>
          <span v-if="itemName" class="item-name">{{ itemName }}&nbsp;</span>
          <small v-if="itemNumber" class="item-number"
            >({{ itemNumber }})</small
          >
          <div v-if="service || createdDate">
            <small v-if="service" class="item-service">{{
              service + " "
            }}</small>
            <small v-if="createdDate" class="item-created">{{
              createdDate
            }}</small>
          </div>
          <div v-if="status || expireDate">
            <cat-pill class="item-status" :value="status" :level="statusCode" />
            <small class="item-expires">{{ expireDate }}</small>
            <cat-pill v-if="pill" class="item-status" :value="pillValue" />
          </div>

          <div v-if="referenceNumber && referenceNumber !== 'Reference No:'">
            <small class="myItemReference">{{ referenceNumber }}</small>
          </div>
          <cat-error
            v-if="notification"
            :level="parseInt(notification.level)"
            :center="false"
            class="small"
          >
            <ul class="alert-items">
              <li class="alert-item">{{ notification.message }}</li>
            </ul>
          </cat-error>
        </div>
      </div>
    </td>
    <td
      :role="roleListItem ? 'group' : null"
      :aria-label="roleListItem ? groupActionsLabel : null"
    >
      <slot></slot>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CatPill from "../catPill/cat-pill";
import CatError from "../catError/catError";
import CatIcon from "../utilities/catIcon";

import DashboardItemsMixin from "./dashboard-items-mixin.js";

export default defineComponent({
  name: "CatActiveItem",
  mixins: [DashboardItemsMixin],
  components: { CatError, CatPill, CatIcon }
});
</script>
